import type { CSSProperties, ReactNode } from "react";
import clsx from "clsx";

const clampScore = (score: number) => Math.max(0, Math.min(100, score));

export const MobileStatusMetric = ({
  "data-dashboard-team-state-metric": dashboardTeamStateMetric,
  "data-roster-health-metric": rosterHealthMetric,
  className,
  detail,
  label,
  score,
  value,
}: {
  "data-dashboard-team-state-metric"?: string;
  "data-roster-health-metric"?: string;
  className?: string;
  detail?: ReactNode;
  label: ReactNode;
  score?: number;
  value: ReactNode;
}) => {
  const normalizedScore = score === undefined ? undefined : Math.round(clampScore(score));
  const style =
    normalizedScore === undefined
      ? undefined
      : ({
          "--mobile-status-hue": normalizedScore * 1.2,
        } as CSSProperties);

  return (
    <div
      className={clsx("mobile-status-metric", className, {
        "mobile-status-metric-unknown": normalizedScore === undefined,
      })}
      data-dashboard-team-state-metric={dashboardTeamStateMetric}
      data-roster-health-metric={rosterHealthMetric}
      data-mobile-status-score={normalizedScore}
      style={style}
    >
      <div className="mobile-status-metric-label">{label}</div>
      <strong className="mobile-status-metric-value">{value}</strong>
      {detail !== undefined ? <div className="mobile-status-metric-detail">{detail}</div> : null}
    </div>
  );
};

export default MobileStatusMetric;
